import React from 'react';
import { VideoPreviewCard } from '@/components/VideoPreviewCard';
import { buildPanelStreamUrlPath, usePanelStreamUrl } from '@/hooks/usePanelStreamUrl';

/** Panel recording card — resolves stream URL when needed, then renders VideoPreviewCard. */
export function PanelRecordingPreview({
  panel,
  shareToken,
  isDemo,
  onOpen,
  className,
  testId,
}) {
  const hasArtifact = !!panel.recording_artifact_id && !isDemo;
  const streamPath = hasArtifact
    ? buildPanelStreamUrlPath({
        panelId: panel.id,
        artifactId: panel.recording_artifact_id,
        shareToken,
      })
    : null;
  const { data: streamUrl, isLoading } = usePanelStreamUrl(streamPath);

  const videoUrl = hasArtifact ? streamUrl : (panel.recording_url || null);

  if (hasArtifact && isLoading) {
    return (
      <div className={className} data-testid={`${testId}-loading`}>
        <div className="aspect-video animate-pulse rounded-xl border bg-secondary/60" />
      </div>
    );
  }

  if (!videoUrl) return null;

  return (
    <VideoPreviewCard
      videoUrl={videoUrl}
      onOpen={onOpen}
      className={className}
      testId={testId || `panel-recording-preview-${panel.id}`}
      heightClass="aspect-video"
    />
  );
}
